import { Pipe, PipeTransform } from '@angular/core';
import { AccountTypeLabels } from '../../../consts/consts';
import { AccountTypeIdEnum } from '../../../models/enum/shared/account-type-id.enum';

@Pipe({
  name: 'accountTypeName',
  standalone: true
})
export class AccountTypeNamePipe implements PipeTransform {
  transform(accountTypeId: AccountTypeIdEnum): string {
    return AccountTypeLabels[accountTypeId];
  }
}
